import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';

import { captureException } from 'shared/utils/handlerErrors';
import SingleSignupContainer from '../signup/components/Signup';
import SingleSignupRoutes from '../signup/components/Routes';
import { loadRecaptcha } from '../signup/services';

const SignupContainer = ({ match: { url } }: RouteComponentProps) => {
  useEffect(() => {
    loadRecaptcha({ autoHideBadge: true }).catch((e) => captureException(e));
  }, []);

  return (
    <SingleSignupContainer>
      <SingleSignupRoutes basePath={url} />
    </SingleSignupContainer>
  );
};

export default SignupContainer;
